import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, ConfirmDialog, ButtonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  getIconClass(message: any): string {
    const icon = message?.icon;
    if (typeof icon === 'string' && icon.trim().length > 0) {
      return icon;
    }
    return 'pi pi-exclamation-triangle';
  }

  getIconContainerClass(message: any): string {
    const acceptClass = `${message?.acceptButtonStyleClass || ''}`.toLowerCase();

    if (acceptClass.includes('danger')) {
      return 'bg-red-500';
    }
    if (acceptClass.includes('warn')) {
      return 'bg-amber-500';
    }
    if (acceptClass.includes('success')) {
      return 'bg-emerald-500';
    }

    return 'bg-primary';
  }

  getRejectLabel(message: any): string {
    return message?.rejectLabel || 'Cancel';
  }

  getAcceptLabel(message: any): string {
    return message?.acceptLabel || 'Confirm';
  }
}
